<template>
    <div class="agency__page" id="content" v-if="result1">

        <div class="intro__holder background-image-holder">
            <div class="wrapper">
                <intro-component :intro="result1.agency.data.attributes.Intro" :isCover="true" :isAnimated="true"></intro-component>
            </div>

            <span class="agency-background">
            </span>

        </div>


        <div class="agency__services marquee__holder">
            <div class="small-wrapper">
                <intro-component :intro="result1.agency.data.attributes.Services" :index="1"></intro-component>
            </div>

            <div class="wrapper">
                <div class="agency__services__holder">
                    <div class="agency__services__service" 
                        data-gsap="divPopin"
                        v-for="(service, index) in result1.agency.data.attributes.ServicesSections">

                        <div class="agency__services__index" >
                            0{{index+1}}
                        </div>
                        <h3>{{service.Title}}</h3>
                        <!-- {{service.Content}} -->
                        <!-- <ul v-html=""></ul> -->
                        <Markdown class="content" :source="service.Content" />

                    </div>
                </div>
            </div>

            <div class="marquee">
                Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/
            </div>

        </div>

        <div class="agency__people">
            <div class="small-wrapper">
                <intro-component :intro="result1.agency.data.attributes.ThePeople" :index="2" :twoColumns="true"></intro-component>
            </div>
            <div class="wrapper">
                <div class="agency__members__holder grid three">

                  <router-link class="agency__member" 
                                data-gsap="divPopin" 
                                data-gsap-start="top 100%"
                                data-gsap-end="top center"
                                v-for="(member, index) in result1.agency.data.attributes.team_members.data" 
                                :key="member.id" 
                                :to="`/team/${member.attributes.slug}`">

                    <!-- <div class="agency__member" v-for="(member, index) in result2.teanMembers.data" :key="member.id" @click="selectedMember = member"> -->
                        <div class="agency__member__nr index__holder">
                            0{{index+1}}.
                        </div>
                        <!-- <div class="agency__member__figure image-parallax"> -->
                        <div class="agency__member__figure">
                            <!-- {{member.attributes.Image.data.attributes.url}} -->
                            <SafeImage 
                                :imageData="member.attributes.Image"
                                :placeholder="PLACEHOLDER_IMAGES.TEAM_MEMBER"
                                placeholderText="Team member photo not available"
                                imageClass="team-member-image"
                                loading="lazy"
                            />
                        </div>
                        <h3>
                            {{member.attributes.firstName}} {{member.attributes.lastName}}
                        </h3>
                        <p>
                            {{member.attributes.position}}
                        </p>

                    </router-link>

                </div>
            </div>
            <span class="contact-noise"></span>

            <span class="team-members-background">
            </span>
        </div>

        <div class="agency__hireus marquee__holder hire-us__holder background-image-holder">
            <div class="wrapper">
                <intro-component :intro="result1.agency.data.attributes.HireUs" :isAnimated="true"></intro-component>

                <!-- <router-link class="badge-button" v-if="result1.agency.data.attributes.Button.label && result1.agency.data.attributes.Button.href" :to="result1.agency.data.attributes.Button.href"
                             data-gsap="fromStartEnd" data-gsap-start="top 70%" data-gsap-end="bottom center" data-gsap-delay="0.4">
                    <span class="badge-button__content">
                        {{ result1.agency.data.attributes.Button.label }}
                        <div class="badge-button__icon">
                            <long-arrow/>
                        </div>
                    </span>
                    <span class="badge-button__rain rotate-badge">
                        <badge-icon/>
                    </span>
                </router-link> -->
                <!-- <button-component  :button="result1.agency.data.attributes.Button" classes="main-accent" data-gsap="fromStartEnd" data-gsap-delay="0.2"></button-component> -->
                <button-component  :button="result1.agency.data.attributes.Button" classes="main-accent" data-gsap="fadeIn" data-gsap-initial-scale="1" data-gsap-delay="0.4" data-gsap-duration="0.2"></button-component>
            </div>

            <div class="marquee">
                Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/
            </div>

            <!-- <span class="contact-shape1"></span>
            <span class="contact-shape2"></span>
            <span class="contact-shape3"><contact-quitar/></span>
            <span class="contact-square"><contact-squares/></span>
            <span class="contact-shape4"></span> -->
            <span class="contact-noise"></span>
            
            <span class="contact-background">
                <!-- <connect-background/> -->
            </span>

        </div>
        <Seo :seoData="result1.agency.data.attributes.seo"/>
    </div>
</template>

<script lang="ts">

    import { defineComponent, ref, watch } from 'vue'
    import gql from 'graphql-tag'

    import { useQuery } from '@vue/apollo-composable'
    import { AGENCY_QUERY } from '../graphql/agency'
    // import { performanceMonitor } from '../utils/performance-monitor'

    import IntroComponent from '../components/IntroComponent.vue'

    import SafeImage from '../components/SafeImage.vue'
    import { PLACEHOLDER_IMAGES } from '../composables/useImageErrorHandler'

    import SingleMember from '../template-parts/agency/SingleMember.vue'
    import ButtonComponent from '../components/ButtonComponent.vue'
    import Markdown from 'vue3-markdown-it';

    import LongArrow from "../components/svg/LongArrow.vue"
    import BadgeIcon from "../components/svg/BadgeIcon.vue"
    import Seo from '../components/navigation/Seo.vue'
    import ContactSquares          from "../components/svg/ContactSquares.vue"
    import ContactQuitar          from "../components/svg/ContactQuitar.vue"
    import AgencySquares          from "../components/svg/AgencySquares.vue"
    import AgencyLeaf          from "../components/svg/AgencyLeaf.vue"
    import AgencyBackground          from "../components/svg/AgencyBackground.vue"
    import TeamMembersBackground          from "../components/svg/TeamMembersBg.vue"
    import ConnectBackground          from "../components/svg/ConnectBackground.vue"

    export default defineComponent({
        components: {
            IntroComponent,
            SafeImage,
            SingleMember,
            ButtonComponent,
            Markdown,
            LongArrow,
            BadgeIcon,
            ContactSquares,
            ContactQuitar,
            AgencySquares,
            AgencyLeaf,
            Seo,
            AgencyBackground,
            TeamMembersBackground,
            ConnectBackground
        },

        setup() {
            const homeurl: string = import.meta.env.VITE_API_URL

            var selectedMember = ref(null);
            console.log(selectedMember);

            const agency_query = ref(AGENCY_QUERY)
            
            // Track GraphQL query performance
            // performanceMonitor.startGraphQLQuery()
            const { result : result1, loading } = useQuery(agency_query)
            
            // Track when query completes
            watch([result1, loading], ([newResult, newLoading]) => {
                if (!newLoading && newResult) {
                    // performanceMonitor.endGraphQLQuery()
                }
            })

            return {
                result1,
                homeurl,
                selectedMember,
                PLACEHOLDER_IMAGES
            }
        },
    })
</script>
